const ORCHESTRATOR_LIVESTREAM_MINIMUM_DURATION = 30

export default ORCHESTRATOR_LIVESTREAM_MINIMUM_DURATION
